import React from "react";
import { Input } from "reactstrap";

const InventorySearchField = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  inputClassName = "form-control",
  disabled = false,
  onKeyDown,
  onFocus,
  onBlur,
}) => {
  const trimmedValue = value || "";

  return (
    <div className={`inventory-search-field ${className}`.trim()}>
      <Input
        type="text"
        value={trimmedValue}
        onChange={(event) => onChange?.(event.target.value)}
        placeholder={placeholder}
        className={inputClassName}
        disabled={disabled}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {trimmedValue ? (
        <button
          type="button"
          className="inventory-search-field__clear inventory-search-field__icon"
          onClick={() => onChange?.("")}
          aria-label="Clear search"
          title="Clear search"
        >
          <i className="tim-icons icon-simple-remove" aria-hidden="true" />
        </button>
      ) : (
        <span className="inventory-search-field__icon" aria-hidden="true">
          <i className="tim-icons icon-zoom-split" />
        </span>
      )}
    </div>
  );
};

export default InventorySearchField;
